import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getReviewGoalsTimelineListApi = ({ employeeId }) => {
  const url = endpoints.performanceReview.timelineList;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      empId: employeeId,
    },
  });
};

export const getOKRWeightageListApi = ({ employeeId, startTS, endTS, formId }) => {
  const url = endpoints.performanceReview.okrWeightageList;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      empId: employeeId,
      startTS,
      endTS,
      formId,
    },
  });
};

export const getPerformancePreviewCompetencyApi = ({ employeeId }) => {
  const url = endpoints.performanceReview.competencyTable;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      empId: employeeId,
    },
  });
};
